import { createFileRoute } from '@tanstack/react-router';
import { ProfileFixesPage } from '@/features/marketing/google-ranking/profile/profile-fixes-page';

export const Route = createFileRoute('/_auth/$orgId/marketing/google-ranking/profile')({
  component: ProfileFixesPage,
});
